<script lang="ts">

  const { children } = $props()

</script>

{@render children()}
